import React from "react";
import Box from "@mui/material/Box";

import SVG from "@/assets/svg";
import CostumeButton from "../button";
import { errorToast } from "../toasts";

interface IUploadFile {
  className?: string;
  onChange?: (e: File | undefined) => void;
}
const MAX_FILE_SIZE = 80 * 1024 * 1024;

function UploadFile({ className, onChange }: IUploadFile) {
  const [fileSelect, setFileSelect] = React.useState<
    string | ArrayBuffer | null
  >("");

  const fileUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      const file = e.target.files[0];

      if (file.size > MAX_FILE_SIZE) {
        errorToast("File size exceeds 80MB limit");
        e.target.value = "";
        return;
      }

      const validTypes = [
        "image/png",
        "image/jpeg",
        "image/jpg",
        "image/gif",
        "application/pdf",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      ];
      if (!validTypes.includes(file.type)) {
        errorToast(
          "Only images (PNG, JPG, GIF), PDF files, and Word documents (DOC, DOCX) are allowed"
        );
        e.target.value = "";
        return;
      }

      const reader = new FileReader();

      reader.onloadend = function () {
        setFileSelect(reader.result);
        onChange && onChange(file);
      };
      reader.readAsDataURL(file);
    }
  };

  const isImage = (base64: string) => {
    return base64.match(
      /^data:image\/(png|jpg|jpeg|gif|svg\+xml);base64,(.*)$/
    );
  };

  return (
    <Box className="upload">
      {fileSelect ? (
        <>
          {isImage(fileSelect as string) ? (
            <div
              className="uploadPhoto"
              style={{ backgroundImage: `url(${fileSelect})` }}
            ></div>
          ) : (
            <div
              className="uploadPhoto"
              style={{
                display: "grid",
                placeItems: "center",
              }}
            >
              <SVG.UploadPdf width="16px" />
            </div>
          )}
        </>
      ) : (
        <>
          <Box sx={{ marginTop: "6%" }}>
            <SVG.Upload />
          </Box>
          <h6 className="files">Upload file</h6>
        </>
      )}
      <Box>
        <Box
          sx={{
            margin: "15px 0px",
            cursor: "pointer",
          }}
        >
          <label htmlFor="file">
            <CostumeButton
              className="invite"
              sx={{ width: "117px", cursor: "pointer" }}
              onClick={() => document.getElementById("file")?.click()}
            >
              Upload
            </CostumeButton>
            <input
              id="file"
              hidden
              className="file"
              type="file"
              onChange={fileUpload}
              // accept=".pdf,.png,.jpg,.jpeg,.gif"
              accept=".pdf,.png,.jpg,.jpeg,.gif,.doc,.docx"
            />
          </label>
        </Box>
      </Box>
    </Box>
  );
}

export default UploadFile;
